export enum OAuthProviders {
	google = 'google',
	facebook = 'facebook',
	microsoft = 'microsoft',
	gitlab = 'gitlab',
	github = 'github',
	apple = 'apple',
	discord = 'discord',
	linkedin = 'linkedin'
}

export const AuthMethods = [
	'otp-email',
	'otp-sms',
	'magiclink-email',
	'magiclink-sms',
	'enchantedlink',
	'totp',
	'oauth',
	'saml',
	'webauthn'
];
